class DataLayer {
  buttons
  constructor() {
    window.dataLayer = window.dataLayer || [];

    this.buttons = document.querySelectorAll('[data-tracking]');
    Array.from(this.buttons).map(button => button.addEventListener('click', (e) => {
      const event = e.currentTarget.dataset.trackingEvent;
      const label = e.currentTarget.dataset.trackingLabel;

      this.pushEvent(event, label);
    }))
  }

  pushEvent(event, label) {
    dataLayer.push({
      event: event || '',
      linktext: label || '',
      page_location: window.location.href,
   });
  }
}

!(async function () {
  if ('complete' === document.readyState) {
    window.tracking = new DataLayer();
  } else {
    window.addEventListener('load', () => {
      window.tracking = new DataLayer();
    });
  }
})();
